export const LENTES_PEL_SET_MODO = 'LENTES_PEL_SET_MODO';
export const LENTES_PEL_SET_VIENE_DE = 'LENTES_PEL_SET_VIENE_DE';
export const LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO = 'LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO';
export const LENTES_PEL_MIS_CATALOGOS_REQUEST = 'LENTES_PEL_MIS_CATALOGOS_REQUEST';
export const LENTES_PEL_MIS_CATALOGOS_SUCCESS = 'LENTES_PEL_MIS_CATALOGOS_SUCCESS';
export const LENTES_PEL_MIS_CATALOGOS_FAILURE = 'LENTES_PEL_MIS_CATALOGOS_FAILURE';
export const LENTES_PEL_MIS_CATALOGOS_MODIFICAR = 'LENTES_PEL_MIS_CATALOGOS_MODIFICAR';
export const LENTES_PEL_CAMBIAR_PANEL_ACTIVO = 'LENTES_PEL_CAMBIAR_PANEL_ACTIVO';
export const LENTES_PEL_RESTABLECER_FILTRO = 'LENTES_PEL_RESTABLECER_FILTRO';
export const LENTES_PEL_FORMULARIO_FILTRO_ESTABLECER_OPCIONES_PANEL = 'LENTES_PEL_FORMULARIO_FILTRO_ESTABLECER_OPCIONES_PANEL';
export const LENTES_PEL_FORMULARIO_INICIALIZAR = 'LENTES_PEL_FORMULARIO_INICIALIZAR';
export const LENTES_PEL_SELECCION_GRADUACION = 'LENTES_PEL_SELECCION_GRADUACION';
export const LENTES_PEL_SELECCION_INDICE = 'LENTES_PEL_SELECCION_INDICE';
export const LENTES_PEL_SELECCION_COLOR = 'LENTES_PEL_SELECCION_COLOR';
export const LENTES_PEL_SELECCION_COLOR_INTENSIDAD = 'LENTES_PEL_SELECCION_COLOR_INTENSIDAD';
export const LENTES_PEL_SELECCION_FABRICANTE = 'LENTES_PEL_SELECCION_FABRICANTE';
export const LENTES_PEL_SELECCION_PASILLO = 'LENTES_PEL_SELECCION_PASILLO';
export const LENTES_PEL_SELECCION_LENTE_TIPO_PVP = 'LENTES_PEL_SELECCION_LENTE_TIPO_PVP';
export const LENTES_PEL_SELECCION_GRADUACION_GENERICA = 'LENTES_PEL_SELECCION_GRADUACION_GENERICA';
export const LENTES_PEL_SELECCION_LENTE = 'LENTES_PEL_SELECCION_LENTE';
export const LENTES_PEL_SELECCION_DIAMETRO = 'LENTES_PEL_SELECCION_DIAMETRO';
export const LENTES_PEL_OBTENER_DATOS_LENTES = 'LENTES_PEL_OBTENER_DATOS_LENTES';
export const LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_REQUEST = 'LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_REQUEST';
export const LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_SUCCESS = 'LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_SUCCESS';
export const LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_FAILURE = 'LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_FAILURE';

export const LENTES_PEL_SELECCION_TRATAMIENTO_LENTE = 'LENTES_PEL_SELECCION_TRATAMIENTO_LENTE';
export const LENTES_PEL_GET_LENTES_LIST_REQUEST = 'LENTES_PEL_GET_LENTES_LIST_REQUEST';

export const LENTES_PEL_GET_ORDEN_GRADUACION_REQUEST = 'LENTES_PEL_GET_ORDEN_GRADUACION_REQUEST';
export const LENTES_PEL_GET_ORDEN_GRADUACION_SUCCESS = 'LENTES_PEL_GET_ORDEN_GRADUACION_SUCCESS';
export const LENTES_PEL_GET_ORDEN_GRADUACION_FAILURE = 'LENTES_PEL_GET_ORDEN_GRADUACION_FAILURE';

export const LENTES_PEL_GET_COLORES_LENTE_REQUEST = 'LENTES_PEL_GET_COLORES_LENTE_REQUEST';
export const LENTES_PEL_GET_COLORES_LENTE_SUCCESS = 'LENTES_PEL_GET_COLORES_LENTE_SUCCESS';
export const LENTES_PEL_GET_COLORES_LENTE_FAILURE = 'LENTES_PEL_GET_COLORES_LENTE_FAILURE';

export const LENTES_PEL_GET_COLORES_REQUEST = 'LENTES_PEL_GET_COLORES_REQUEST';
export const LENTES_PEL_GET_COLORES_SUCCESS = 'LENTES_PEL_GET_COLORES_SUCCESS';
export const LENTES_PEL_GET_COLORES_FAILURE = 'LENTES_PEL_GET_COLORES_FAILURE';
export const LENTES_PEL_GET_FABRICANTES_REQUEST = 'LENTES_PEL_GET_FABRICANTES_REQUEST';
export const LENTES_PEL_GET_FABRICANTES_SUCCESS = 'LENTES_PEL_GET_FABRICANTES_SUCCESS';
export const LENTES_PEL_GET_FABRICANTES_FAILURE = 'LENTES_PEL_GET_FABRICANTES_FAILURE';

export const LENTES_PEL_GET_LENTESTIPOSPVP_REQUEST = 'LENTES_PEL_GET_LENTESTIPOSPVP_REQUEST';
export const LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS = 'LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS';
export const LENTES_PEL_GET_LENTESTIPOSPVP_FAILURE = 'LENTES_PEL_GET_LENTESTIPOSPVP_FAILURE';

export const LENTES_PEL_GET_DIAMETROS_POSIBLES_REQUEST = 'LENTES_PEL_GET_DIAMETROS_POSIBLES_REQUEST';
export const LENTES_PEL_GET_DIAMETROS_POSIBLES_SUCCESS = 'LENTES_PEL_GET_DIAMETROS_POSIBLES_SUCCESS';
export const LENTES_PEL_GET_DIAMETROS_POSIBLES_FAILURE = 'LENTES_PEL_GET_DIAMETROS_POSIBLES_FAILURE';

export const LENTES_PEL_GET_LENTES_LIST_SUCCESS = 'LENTES_PEL_GET_LENTES_LIST_SUCCESS';
export const LENTES_PEL_GET_LENTES_LIST_FAILURE = 'LENTES_PEL_GET_LENTES_LIST_FAILURE';

export const CLEAR_LENTES_LIST_ACTION = 'CLEAR_LENTES_LIST_ACTION';
export const NEXT_PAGE_LENTES_LIST = 'NEXT_PAGE_LENTES_LIST';

export const LENTES_PEL_GET_PASILLOS_REQUEST = 'LENTES_PEL_GET_PASILLOS_REQUEST';
export const LENTES_PEL_GET_PASILLOS_SUCCESS = 'LENTES_PEL_GET_PASILLOS_SUCCESS';
export const LENTES_PEL_GET_PASILLOS_FAILURE = 'LENTES_PEL_GET_PASILLOS_FAILURE';

export const LENTES_PEL_GET_INDICES_REQUEST = 'LENTES_PEL_GET_INDICES_REQUEST';
export const LENTES_PEL_GET_INDICES_SUCCESS = 'LENTES_PEL_GET_INDICES_SUCCESS';
export const LENTES_PEL_GET_INDICES_FAILURE = 'LENTES_PEL_GET_INDICES_FAILURE';

export const OBTENER_SUPLEMENTOS_LENTE_REQUEST = 'OBTENER_SUPLEMENTOS_LENTE_REQUEST';
export const OBTENER_SUPLEMENTOS_LENTE_SUCCESS = 'OBTENER_SUPLEMENTOS_LENTE_SUCCESS';
export const OBTENER_SUPLEMENTOS_LENTE_FAILURE = 'OBTENER_SUPLEMENTOS_LENTE_FAILURE';

export const OBTENER_MATERIALES_BISELADO_LENTE_REQUEST = 'OBTENER_MATERIALES_BISELADO_LENTE_REQUEST';
export const OBTENER_MATERIALES_BISELADO_LENTE_SUCCESS = 'OBTENER_MATERIALES_BISELADO_LENTE_SUCCESS';
export const OBTENER_MATERIALES_BISELADO_LENTE_FAILURE = 'OBTENER_MATERIALES_BISELADO_LENTE_FAILURE';

export const LENTES_PEL_PROCESS_FINAL_SELECTION = 'LENTES_PEL_PROCESS_FINAL_SELECTION';
export const LENTES_PEL_SET_FINAL_SELECTION = 'LENTES_PEL_SET_FINAL_SELECTION';

export const LENTES_PEL_SET_INICIALIZADO = 'LENTES_PEL_SET_INICIALIZADO';
export const LENTES_PEL_SET_DIAMETRO_MINIMO = 'LENTES_PEL_SET_DIAMETRO_MINIMO';
export const LENTES_PEL_ESTABLECER_DNP_OBLIGATORIO = 'LENTES_PEL_ESTABLECER_DNP_OBLIGATORIO';

export const LENTES_PEL_SET_ALTURA_FOCAL = 'LENTES_PEL_SET_ALTURA_FOCAL';

export const SET_ERROR_SELECCION_LENTE = 'SET_ERROR_SELECCION_LENTE';

export const LENTES_PEL_SET_SEARCH_VALUE = 'LENTES_PEL_SET_SEARCH_VALUE';
export const LENTES_PEL_CLEAR_TOOLBAR_DATA = 'LENTES_PEL_CLEAR_TOOLBAR_DATA';

export const LENTES_PEL_SET_FUERA_NORMA = 'LENTES_PEL_SET_FUERA_NORMA';
